var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.302 4.483h-.917v-.65a.5.5 0 10-1 0v.65H7.71v-.65a.5.5 0 10-1 0v.65h-.742a2.092 2.092 0 00-2.1 2.084V14.9a1.916 1.916 0 001.917 1.917h8.517a1.925 1.925 0 001.925-1.917V6.392a1.925 1.925 0 00-1.925-1.909zm.925 10.442a.925.925 0 01-.925.908H5.785a.917.917 0 01-.917-.916V7.958h9.1a.5.5 0 100-1h-9.1v-.391a1.092 1.092 0 011.1-1.092h.75v.408a.5.5 0 001 0v-.408h4.684v.408a.5.5 0 001 0v-.408h.9a.925.925 0 01.925.917v8.533z",
    fill: "#0DD1C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.838 9.636a.469.469 0 010 .663l-2.813 2.813a.469.469 0 01-.662 0l-1.608-1.607a.469.469 0 11.663-.663l1.276 1.275 2.481-2.48a.469.469 0 01.663 0z",
    fill: "#0DD1C5"
  })));
}
export default SvgCalendarSuccess;